import Reflux from "reflux";
import { ActionsMediaAssetsLab } from "../Actions/ActionsMediaAssetsLab/ActionsMediaAssetsLab";
import database from "../utils/FirebaseController";
import Actions, { callWebUtils } from "../Actions";
import logger from "../utils/LoggerFrontend";
import { defaultTeaserTemplates } from "./PreviewStore";
import { channelsByShortName } from "../data/app__channels";
import { t } from "i18next";

export const DEFAULT_INPUT_PROPS = () => ({
  primaryTextColor: "#ffffff",
  primaryBackgroundColor: "#005ea8",
  secondaryTextColor: "#ffffff",
  secondaryBackgroundColor: "#a5a5a5",
  text: t("We are looking for you"),
  secondaryText: t("Are you ready?"),
  CTAText: t("Apply now"),
  blobSize: 70,
  backgroundImage: "",
  logo: "",
  orientation: "portrait",
  duration: 20,
  video:
    "https://res.cloudinary.com/dyiuxe5fa/video/upload/c_crop,h_1080,w_1080,x_464,y_0,ar_1/v1721906886/tb-campaign-photos/pronto/pronto/a6309d65340cd6375624647eeca55da3.mp4",
  benefits: [
    t("Training starts in September of each year and takes three and a half years."),
    t("With good performance and corresponding grades, you can shorten it to three years."),
    t("This is your chance: Come to Rolls-Royce, bring your knowledge and ideas")
  ],
  audioUrl: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Abenteurlich.mp3",
  imageUrl: "",
  logoUrl: "",
  outroText: t("Start with us now"),
  isRegeneratingLabText: false,
  logoPosition: "top-left",
  logoSize: "mid"
});

export default class MediaAssetsLabStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      showMediaAssetsLabModal: false,
      previewInputProps: DEFAULT_INPUT_PROPS(),
      previewInputPropsEdited: false,
      editedCampaignId: "",
      autoGeneratedData: "",
      isAutoGeneratedDataEmpty: true,
      selectedTemplates: [],
      lastPreviewImages: [],
      lastPreviewLogos: [],
      loadingCloudinaryImages: false,
      loadingDefaultImages: false,
      defaultCreativesLab: [],
      previewSelectedAsset: "",
      templateInputProps: {}
    };

    this.listenables = ActionsMediaAssetsLab;
  }

  onSetCompanyLogo(logos) {
    const { newLogosUrls } = this.generateNewUrl({ images: [], logos: logos });
    this.setState({ lastPreviewLogos: [...this.state.lastPreviewLogos, ...newLogosUrls] });
  }

  onToggleModal() {
    this.setState({ showMediaAssetsLabModal: !this.state.showMediaAssetsLabModal });
  }

  onChangePreviewInputProps({ key, value }) {
    this.setState({
      previewInputProps: { ...this.state.previewInputProps, [key]: value }
    });
  }

  onSetPreviewInputPropsEdited() {
    this.setState({ previewInputPropsEdited: true });
  }

  onSetEditedCampaignId(campaignId) {
    this.setState({ editedCampaignId: campaignId });
  }

  onConstructTemplateInputProps(templateKey) {
    const updatedTemplateInputProps = {
      ...this.state.templateInputProps,
      [templateKey]: {
        ...this.state.previewInputProps,
        isCropped: false
      }
    };

    this.setState({ templateInputProps: updatedTemplateInputProps });
  }

  onChangeTemplateInputProps({ templateKey = null, key, value }) {
    const updatedTemplateInputProps = { ...this.state.templateInputProps };

    if (templateKey) {
      updatedTemplateInputProps[templateKey] = {
        ...this.state.templateInputProps[templateKey],
        [key]: value
      };
    } else {
      Object.keys(updatedTemplateInputProps).forEach((template) => {
        updatedTemplateInputProps[template] = {
          ...updatedTemplateInputProps[template],
          [key]: value
        };
      });
    }

    this.setState({ templateInputProps: updatedTemplateInputProps });
  }

  onChangeLabProps({ key, value }) {
    this.setState({ [key]: value });
  }

  onSelectTemplate(selectedTemplates) {
    this.setState({ selectedTemplates });
  }

  onSelectImage(selectedImage) {
    this.setState({
      lastPreviewImages: [...this.state.lastPreviewImages, selectedImage]
    });
  }

  onSelectLogo(selectedImage) {
    this.setState({ lastPreviewLogos: [...this.state.lastPreviewLogos, selectedImage] });
  }

  onSelectPreviewSelectedAsset(selectedAsset) {
    this.setState({ previewSelectedAsset: selectedAsset });
  }

  generateNewUrl({ images = [], logos = [] }) {
    const normalizeUrl = (url) => url.replace(/^https?:\/\//, "");

    const newUrls = images.filter(
      (url) => !this.state.lastPreviewImages.map(normalizeUrl).includes(normalizeUrl(url))
    );

    const newLogosUrls = logos.filter(
      (url) => !this.state.lastPreviewLogos.map(normalizeUrl).includes(normalizeUrl(url))
    );

    return { newUrls, newLogosUrls };
  }

  onGetAssetsByCampaignId(campaignId, defaultCreatives) {
    if (defaultCreatives?.length === 0) {
      this.setState({ loadingCloudinaryImages: false });
      return;
    }

    const { newUrls } = this.generateNewUrl({ images: defaultCreatives, logos: [] });

    this.setState({
      loadingDefaultImages: true,
      defaultCreativesLab: [...this.state.lastPreviewImages, ...newUrls]
    });
  }

  onGetAssetsByCampaignIdCompleted({ payload: { backgroundImages: images, logos } }) {
    if (images.length === 0) {
      this.setState({
        loadingDefaultImages: false,
        lastPreviewImages: this.state.defaultCreativesLab
      });
    }

    if (images.length === 0 && logos.length === 0) {
      this.setState({ loadingDefaultImages: false });
      return;
    }

    const { newUrls, newLogosUrls } = this.generateNewUrl({ images, logos });

    this.setState({
      lastPreviewImages: [...this.state.lastPreviewImages, ...newUrls],
      lastPreviewLogos: [...this.state.lastPreviewLogos, ...newLogosUrls],
      loadingDefaultImages: false
    });
  }

  onGetAssetsByCampaignIdFailed(e) {
    this.setState({ loadingDefaultImages: false });
  }

  onGetCloudinaryImages() {
    this.setState({
      loadingCloudinaryImages: true
    });
  }

  onGetCloudinaryImagesCompleted({ payload: { images = [], logos = [], videos = [] } }) {
    if (images.length === 0 && logos.length === 0 && videos.length === 0) {
      this.setState({ loadingCloudinaryImages: false });
      return;
    }

    const lastPreviewAssets = images.concat(videos);
    const { newUrls, newLogosUrls } = this.generateNewUrl({ images: lastPreviewAssets, logos });

    this.setState({
      lastPreviewImages: [...this.state.lastPreviewImages, ...newUrls],
      lastPreviewLogos: [...this.state.lastPreviewLogos, ...newLogosUrls],
      loadingCloudinaryImages: false
    });
  }

  onGetCloudinaryImagesFailed(e) {
    this.setState({ loadingCloudinaryImages: false });
  }

  async onGenerateMediaAssets({
    selectedChannels,
    userName,
    campaignId,
    existingPosts,
    isReleased
  }) {
    // Initialize an array to store all media assets
    const mediaAssets = [];
    const creativeAssets = [];
    const assetIdMap = {}; // Map to keep track of asset IDs assigned to posts

    // Iterate over each channel and its posts
    for (const [channel, posts] of Object.entries(selectedChannels)) {
      for (const postId of posts) {
        // For each post and template, create a media asset
        this.state.selectedTemplates.forEach((template) => {
          const { templateKey, isMultiOrientation, templateOrientation } = template;

          const previewInputProps = this.state.templateInputProps[templateKey];
          let templateId = templateKey;
          let orientation = previewInputProps.orientation;

          if (isMultiOrientation) {
            const splitTemplateName = templateKey.split("_");
            templateId = splitTemplateName[0];
            orientation = templateOrientation;
          }

          creativeAssets.push(previewInputProps.backgroundImage);
          mediaAssets.push({
            templateId,
            inputProps: { ...previewInputProps, postId, orientation },
            type: templateId.includes("Video") ? "video" : "image",
            createdDate: new Date().toISOString(),
            channel
          });
        });
      }
    }

    // Create media assets sequentially and collect results
    const results = [];
    const usedIds = new Set();

    for (const asset of mediaAssets) {
      try {
        const ref = await database.createMediaAsset(asset);
        if (ref?.id) {
          logger.log(`Asset saved successfully with ID: ${ref.id}`);
          results.push({ id: ref.id, success: true, ...asset });
          const { inputProps, channel } = asset;
          if (!assetIdMap[channel]) {
            assetIdMap[channel] = {};
          }
          if (!assetIdMap[channel][inputProps.postId]) {
            assetIdMap[channel][inputProps.postId] = [];
          }
          assetIdMap[channel][inputProps.postId].push(ref.id);
          usedIds.add(ref.id); // Track used IDs
        } else {
          logger.error("Error: No ID returned for asset.");
          results.push({ success: false, error: "No ID returned", ...asset });
        }
      } catch (error) {
        logger.error("Error saving asset: ", error);
        results.push({ success: false, error, ...asset });
      }
    }

    // Handle or log results
    const successfulSaves = results.filter((result) => result.success);
    logger.log(`${successfulSaves.length} out of ${mediaAssets.length} assets saved successfully.`);

    const failedSaves = results.filter((result) => !result.success);
    if (failedSaves.length > 0) {
      logger.error("Some assets failed to save: ", failedSaves);
    }

    try {
      await Actions.updatePostMediaLab({
        assetIdMap,
        existingPosts,
        creativeAssets,
        userName,
        campaignId,
        isReleased
      });
      Actions.addNotification("Assets assigned to posts successfully");
    } catch (error) {
      Actions.addNotification("Error assigning media assets", "error");
    }
  }

  async onGenerateMediaAssetsTextStream(body) {
    this.setState({ isAutoGeneratedDataEmpty: false });

    await this.generateMediaAssetsTextStream(body);

    this.onChangePreviewInputProps({
      key: "isRegeneratingLabText",
      value: false
    });
  }

  async generateMediaAssetsTextStream(props) {
    logger.log("MediaAssetsLabStore:generateMediaAssetsTextStream", "called", props);

    const { channel, jobTitle, jobPostingUrl, language = "German", formality } = props;

    try {
      const context = {
        failed: (err) => {
          this.onChangePreviewInputProps({
            key: "isRegeneratingLabText",
            value: false
          });
          throw err;
        },
        completed: () => {
          this.onChangePreviewInputProps({
            key: "isRegeneratingLabText",
            value: false
          });
        }
      };

      let autoGeneratedText = "";
      let autoGeneratedData;

      await callWebUtils(context, "generateTextRecommendationStream", [
        {
          body: {
            channel,
            jobTitle,
            jobPostingUrl,
            language,
            formality
          },
          onData: (textChunk) => {
            autoGeneratedText += textChunk || "";

            if (!textChunk) {
              return;
            }

            if (channel !== "google-search") {
              autoGeneratedData = autoGeneratedText;
            } else {
              let jsonText = autoGeneratedText;
              let quotationsCount = 0;
              let openBracketsCount = 0;
              let closeBracketsCount = 0;
              let openCurlyBracesCount = 0;
              let closeCurlyBracesCount = 0;

              if (jsonText) {
                for (let i = 0; i < jsonText.length; i++) {
                  if (jsonText[i] === '"') {
                    quotationsCount++;
                  }
                  if (jsonText[i] === "[") {
                    openBracketsCount++;
                  }
                  if (jsonText[i] === "]") {
                    closeBracketsCount++;
                  }
                  if (jsonText[i] === "{") {
                    openCurlyBracesCount++;
                  }
                  if (jsonText[i] === "}") {
                    closeCurlyBracesCount++;
                  }
                }
              }

              if (quotationsCount % 2 !== 0) {
                jsonText += '"';
              }
              jsonText += Array(Math.max(0, openBracketsCount - closeBracketsCount))
                .fill("]")
                .join("");
              jsonText += Array(Math.max(0, openCurlyBracesCount - closeCurlyBracesCount))
                .fill("}")
                .join("");

              try {
                const { ad = "" } = JSON.parse(jsonText);
                autoGeneratedData = ad;
              } catch (err) {
                logger.log(
                  "MediaAssetsLabStore:generateMediaAssetsTextStream",
                  "could not parse google search stream"
                );
              }
            }

            this.onChangeLabProps({ key: "autoGeneratedData", value: autoGeneratedData });
          }
        }
      ]);
    } catch (err) {
      logger.log("MediaAssetsLabStore:fallbackText", "error", {
        err
      });

      const fallbackText = this.getDefaultTeaserText({
        channelShortName: channel,
        jobTitle: this.state.campaignData?.jobTitle
      });

      Actions.addNotification(
        t("Currently it was not possible to generate your text using AI"),
        "info",
        false,
        6
      );

      return fallbackText;
    }
  }

  getDefaultTeaserText({ channelShortName, jobTitle }) {
    const text = defaultTeaserTemplates[0].replace("{{jobTitle}}", jobTitle);
    return text.substring(0, channelsByShortName[channelShortName]?.limits?.teaserText || 500);
  }
}
